const base_url='https://ke.trickso.com';
export {base_url}

const subscribe_api = `${base_url}/subscribe-user`
export {subscribe_api}

const updateStatusApi = `${base_url}/update/activation-logs`
export {updateStatusApi}